import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import uniqueId from 'lodash/uniqueId';

import Radio from '@mos-front-components/public/es/components/Radio';

import { APPLICANT_TYPES } from '../../constants/applicant';
import { changeApplicantType } from '../../store/applicant/actions';
import { saveDraft } from '../../store/draft/actions';

import structuredSelector from './structuredSelector';

import './StepApplicantType.pcss';

const StepApplicantType = ({
  applicantType,
  completeSTEP1,
  changeApplicantType,
  saveDraft
}) => {
  const formId = uniqueId();

  if (!completeSTEP1) {
    return null;
  }

  return (
    <div className="StepApplicant">
      <Radio
        className="StepApplicant__radio"
        name={`participant_${formId}`}
        value="participant"
        checked={applicantType === APPLICANT_TYPES.participant}
        onChange={() => {
          changeApplicantType(APPLICANT_TYPES.participant);
          saveDraft();
        }}
        label="Участник ГИА"
      />
      <Radio
        className="StepApplicant__radio"
        name={`participant_${formId}`}
        value="parent"
        checked={applicantType === APPLICANT_TYPES.parent}
        onChange={() => {
          changeApplicantType(APPLICANT_TYPES.parent);
          saveDraft();
        }}
        label="Законный представитель участника ГИА"
      />
    </div>
  );
};

StepApplicantType.propTypes = {
  applicantType: PropTypes.oneOf([
    APPLICANT_TYPES.parent,
    APPLICANT_TYPES.participant
  ]),
  completeSTEP1: PropTypes.bool.isRequired,
  changeApplicantType: PropTypes.func.isRequired
};

StepApplicantType.defaultProps = {
  applicantType: null
};

export default compose(
  connect(structuredSelector, dispatch =>
    bindActionCreators(
      {
        changeApplicantType,
        saveDraft
      },
      dispatch
    )
  )
)(StepApplicantType);
